import axios from "axios";
import { getUrl } from "@/common/config";

export default {
  state: {
    activities: {},
    shifts: []
  },
  getters: {
    activities: state => {
      return state.activities;
    },
    shifts: state => state.shifts
  },
  mutations: {
    getActivities(state, data) {
      state.activities = data;
    },
    saveShifts(state, data) {
      state.shifts = data;
    }
  },
  actions: {
    async getActivities({ commit }, arg) {
      try {
        axios
          .get(`${getUrl()}/api/machines/${arg.id}/status/historical-aggregated`, {
            params: {
              aggregatedBy: "days",
              from: arg.from,
              to: arg.to
            }
          })
          .then(response => commit("getActivities", response.data.result.statuses));
      } catch (e) {
        commit("getActivities", {});
      }
    },
    getShifts({ commit }) {
      try {
        axios
          .get("", {
            params: {}
          })
          .then(response => commit("saveShifts", response.data.result));
      } catch (e) {
        commit("saveShifts", {});
      }
    }
  },
  namespaced: true
};
